"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtcEngineDispatchExtensions = void 0;
const IAgoraRtcEngineDispatch_1 = require("../binding/IAgoraRtcEngineDispatch");
const IAgoraRtcEngineImpl_1 = require("../impl/IAgoraRtcEngineImpl");
class RtcEngineDispatchExtensions extends IAgoraRtcEngineDispatch_1.IRtcEngineDispatch {
    constructor(engine) {
        super(engine);
        this._impl = new IAgoraRtcEngineImpl_1.IRtcEngineImpl(engine);
    }
    setAppType(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let appType = obj.appType;
        if (appType === undefined)
            throw 'appType is undefined';
        return this._impl.setAppType(appType);
    }
    release(apiParam) {
        return this._impl.release();
    }
}
exports.RtcEngineDispatchExtensions = RtcEngineDispatchExtensions;
